import React, { Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Homepage from "./homepage/index";
import LandingAlt from "./homepage/LandingAlt";
import About from "./homepage/About";
import Team from "./homepage/Team";
import Blog from "./homepage/Blog";
import BlogDetail from "./homepage/BlogDetail";
import Service from "./homepage/Service";
import ServiceDetail from "./homepage/ServiceDetail"
import Contact from "./homepage/Contact"
import Faq from "./homepage/Faq"
import Terms from "./homepage/Terms";
import Privacy from "./homepage/Privacy";
import Imprint from "./homepage/Imprint";

const Index = (props) => {
  return (
    <Fragment>
      <Router forceRefresh>
        <Switch>
          <Route exact path="/">
            <Homepage />
          </Route>
          <Route exact path="/landing-alt">
            <LandingAlt />
          </Route>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/team">
            <Team />
          </Route>
          <Route exact path="/blog">
            <Blog />
          </Route>
          <Route exact path="/blog/detail">
            <BlogDetail />
          </Route>
          <Route exact path="/service">
            <Service />
          </Route>
          <Route exact path="/service/detail">
            <ServiceDetail />
          </Route>
          <Route exact path="/contact">
            <Contact />
          </Route>
          <Route exact path="/faq">
            <Faq />
          </Route>
          <Route exact path="/terms">
            <Terms />
          </Route>
          <Route exact path="/privacy">
            <Privacy />
          </Route>
          <Route exact path="/impressum">
            <Imprint />
          </Route>
        </Switch>
      </Router>
    </Fragment>
  );
};

export default Index;
